// T-137 (v1.8.39, Session 37, 29.09.2026): Hinweise des Gastes bzw. Anmerkungen der Verwaltung (bookings.special_requests) für die
// Anzeige. Die Verwaltungsbuchung schreibt ohne Anmerkung automatisch "Admin-Buchung erstellt am TT.MM.JJJJ HH:MM"; dieser Vermerk
// ist keine Information für Gast oder Verwaltung. Gleiche Erkennung wie Business.Buchung.Gasthinweis im Backend (v1.8.36).

const AUTO_VERMERK = /^Admin-Buchung erstellt am \d{2}\.\d{2}\.\d{4}( \d{2}:\d{2})?$/;

/** Anzeigetext oder null (leer oder nur automatischer Vermerk). */
export function gastHinweis(text: string | null | undefined): string | null {
  if (!text) return null;
  const t = text.trim();
  if (!t || AUTO_VERMERK.test(t)) return null;
  return t;
}
